<app-main>
  <tup-page-not-found
    (platformHomepageClicked)="goToPlatform()"
  ></tup-page-not-found>
</app-main>
